import { useState } from 'react'
import { BillingAddressForm } from 'grabbitbot-legacy-ui'
import { paymentClient } from '../../api'
import { PaymentNotice, PaymentPage } from './paymentShared'

/**
 * `/payment/billing` — legacy `PaymentBillingViewComponent`: view / edit the
 * billing address printed on invoices (`GET` / `PATCH /payment/billing`).
 * The form is the shared library's `BillingAddressForm` (same component the
 * screener uses); the backend overwrites only the fields it knows, trimmed.
 */
export function PaymentBillingPage() {
  const [saved, setSaved] = useState(false)
  return (
    <PaymentPage title="Billing">
      <section className="portal-card" aria-label="Billing information">
        <h2>Billing information</h2>
        <p className="portal-text-muted">This address appears on your invoices.</p>
        <BillingAddressForm className="portal-form" payment={paymentClient} onSaved={() => setSaved(true)} />
        {saved && <PaymentNotice feedback={{ tone: 'success', text: 'Billing information saved.' }} />}
      </section>
    </PaymentPage>
  )
}
